import { contentsSection } from "./contents-section";

export const productDetail = {
	isActive: "Producto activo",
	isInactive: "Producto inactivo",
	buttonEditProduct: "Editar producto",
	variable: "Variable",
	modalDeleteProduct: {
		titleModal: "Confirmación necesaria",
		confirmDeleteProduct: "¿Desea eliminar el producto: {{productName}}",
	},
	sectionsCards: {
		productDetail: "Detalles del producto",
		fiscalData: "Datos fiscales",
		cardProductSoldBy: "Producto vendido por g/ml",
		cardProductMountable: "Producto montable",
		releaseValue: "Precio de suelta",
		conversionRule: "Regla de conversión",
	},
	duplicateProductMountable: "Duplicar producto montable",
	contentsSection,
};
